import { Component, ElementRef, HostListener, inject, Inject, OnInit, PLATFORM_ID, signal, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from "./layout/header/Component/header.component";
import { isPlatformBrowser } from '@angular/common';
import { NewsletterComponent } from "./pages/newsletter/Component/newsletter.component";
import { FooterComponent } from './layout/footer/Components/footer.component';
import { loginService } from './pages/login/Services/login.service';
import { AuthService } from './shared/service/auth.service';
import { imageService } from './shared/service/image.service';
import { LoaderComponent } from "./pages/loader.component.ts/loader.component";

@Component({
  selector: 'app-root',
  imports: [HeaderComponent, FooterComponent, RouterOutlet, NewsletterComponent, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {

  //=================================================================== start back to top
  @ViewChild('progressWrap', { static: true }) progressWrap!: ElementRef<HTMLDivElement>;
  @ViewChild('progressPath', { static: true }) progressPath!: ElementRef<SVGPathElement>;
  showBackToTop = false;
  private pathLength!: number;
  private imageService = inject(imageService)

  ngAfterViewInit() {
    const path = this.progressPath.nativeElement;
    this.pathLength = path.getTotalLength();

    path.style.transition = 'none';
    path.style.strokeDasharray = `${this.pathLength} ${this.pathLength}`;
    path.style.strokeDashoffset = this.pathLength.toString();
    path.getBoundingClientRect();
    path.style.transition = 'stroke-dashoffset 10ms linear';
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scroll = window.scrollY;
    const height = document.documentElement.scrollHeight - window.innerHeight;
    const progress = this.pathLength - (scroll * this.pathLength / height);
    this.progressPath.nativeElement.style.strokeDashoffset = progress.toString();
    this.showBackToTop = scroll > 50;
    const opacity = scroll / height;
    this.progressWrap.nativeElement.style.background = `rgba(255, 102, 0, ${opacity})`;
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  //=================================================================== end back to top
  //=================================================================== start loading 
  loading = signal(true);

  constructor() {
    // this.captureTokenFromUrl();
  }

  ngOnInit(): void {
    // localStorage.setItem("lang", "en")
    setTimeout(() => {
      this.loading.set(false);
    }, 1000);
  }
  // ================================================================== end loading
  // ============================================================ start toogle menu

  // ============================================================ end toogle menu

  // captureTokenFromUrl() {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const token = urlParams.get('token');
  //   const userId = localStorage.getItem("userId")

  //   if (token && !userId) {
  //     localStorage.setItem('token', token);
  //     this.loginService.GetCurrentUser().subscribe({
  //       next: (res: any) => {
  //         localStorage.setItem("userId", res.value.id);
  //         localStorage.setItem("isMember", res.value.isMember);
  //         localStorage.setItem("userName", res.value.userName);
  //         localStorage.setItem("isAdmin", res.value.isAdmin);
  //       }
  //     })
  //     this.authService.setLoggedIn();

  //     // نظّفي الـ URL عشان ميظهرش الـ token
  //     window.history.replaceState({}, '', window.location.pathname);
  //   }
  // }
}
